import { useSite } from "../context/SiteContext";
import { bust } from "../lib/imgUrl";

export default function About() {
  const { content, versions } = useSite();
  return (
    <section id="about" className="section relative" data-testid="about-section">
      <div className="container-x px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="wm-wrap rounded-2xl overflow-hidden border border-[rgba(201,169,97,0.15)] shadow-[0_30px_80px_-40px_rgba(0,0,0,0.9)]">
              <img
                src={bust("/gallery/about.jpg", versions)}
                alt="Camilla portrait"
                className="w-full h-auto object-cover"
                onContextMenu={(e) => e.preventDefault()}
                draggable={false}
                data-testid="about-portrait"
              />
            </div>

            <div className="card-luxe mt-6 p-6" data-testid="about-stats-card">
              <div className="eyebrow mb-4">Vitals</div>
              <div className="grid grid-cols-2 gap-x-6 gap-y-4">
                {(content.stats || []).map((s) => (
                  <div key={s.label} className="flex flex-col">
                    <span className="text-[0.65rem] tracking-[0.24em] uppercase text-[color:var(--muted)]">
                      {s.label}
                    </span>
                    <span className="font-serif text-lg text-ivory mt-1">
                      {s.value}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="eyebrow mb-5" data-testid="about-eyebrow">
              Meet Camilla
            </div>
            <h2
              className="font-display text-4xl sm:text-5xl md:text-6xl text-gold mb-8 leading-tight"
              data-testid="about-heading"
            >
              A little bit of trouble,{" "}
              <span className="italic text-ivory">a lot of fun.</span>
            </h2>

            <div className="space-y-5 text-ivory-dim text-base md:text-lg leading-relaxed">
              {(content.about_me || []).map((p, i) => (
                <p key={i} data-testid={`about-para-${i}`}>
                  {p}
                </p>
              ))}
            </div>

            <div className="flex flex-wrap gap-2 mt-8" data-testid="personality-tags">
              {(content.personality_tags || []).map((t) => (
                <span key={t} className="pill">
                  {t}
                </span>
              ))}
            </div>

            <div className="hairline my-12" />

            <div className="eyebrow mb-4">What to Expect</div>
            <ul className="space-y-4">
              {(content.what_to_expect || []).map((w, i) => (
                <li
                  key={i}
                  className="flex gap-3 text-ivory-dim leading-relaxed"
                  data-testid={`expect-item-${i}`}
                >
                  <span className="text-gold mt-1.5 flex-shrink-0">◆</span>
                  <span>{w}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
